import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import Button from '../../../../base/Button';
import { Container, Col } from '../../../../base/Grid';

export const ButtonCloseStyled = styled.button`
  ${({ theme, activeAnnouncement }) => {
    // percentage it starts at if the annoucnement is active for the x-button fix
    let shiftVal = '50%';
    if (!activeAnnouncement) {
      // set to 92% if it's on a medium or above display
      shiftVal = '92%';
    }

    return css`
      position: absolute;
      top: 0;
      right: 0;
      width: ${rem(42)};
      min-width: unset;
      padding: ${rem(12)};
      border: none;
      float: right;
      left: ${theme.mediumUp() ? shiftVal : 'unset'};
      background: transparent;
      svg {
        height: ${rem(16)};
        width: ${rem(16)};
      }
      :hover {
        cursor: pointer;
      }
    `;
  }}
`;

export const ButtonLoginStyled = styled(Button)`
  display: block;
  margin: auto;
  margin-bottom: ${rem(16)};
`;

export const CheckboxInputStyled = styled.input`
  display: flex;
  align-items: center;
  margin-top: ${rem(2)};
  margin-left: ${rem(10)};
`;

export const ColAnnouncementStyled = styled(Col)`
  ${({ theme }) => css`
    padding: ${theme.mediumUp() ? rem(48) : rem(16)};
    background-color: ${theme.colors.neutral.gray95};
    text-align: center;
    .icon-login-got-easier {
      display: ${theme.mediumUp() ? 'inline-block' : 'none'};
    }
  `}
`;

export const ColFormStyled = styled(Col)`
  margin-bottom: ${rem(16)};
`;

export const ColLoginContentStyled = styled(Col)`
  ${({ theme }) => css`
    padding: ${theme.mediumUp() ? rem(48) : rem(16)};
  `}
`;

export const ContainerModalStyled = styled(Container)`
  ${({ theme }) => {
    let width = '100%';
    const mediumUp = theme.mediumUp();
    const largeUp = theme.largeUp();
    const xlargeUp = theme.xlargeUp();

    if (xlargeUp) {
      width = '60%';
    } else if (largeUp) {
      width = '75%';
    } else if (mediumUp) {
      width = '90%';
    }
    return css`
      .is-active {
        display: block;
      }
      padding: 0;
      position: absolute;
      z-index: ${theme.zIndex.modalMain};
      display: none;
      width: ${width};
      max-width: ${xlargeUp ? rem(900) : rem(800)};
      height: ${mediumUp ? 'auto' : '100%'};
      border: 0;
      margin: 0 auto;
      backface-visibility: hidden;
      background-color: ${theme.colors.neutral.white};
      box-shadow: none;
      overflow-y: ${mediumUp ? 'auto' : 'scroll'};
      border-radius: ${mediumUp ? rem(4) : 0};
      min-height: ${mediumUp ? rem(300) : 0};
      ${largeUp && 'overflow: hidden;'}
    `;
  }}
`;

export const DivLoginErrorStyled = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    padding: ${rem(16)};
    border-left: ${rem(5)} solid ${theme.colors.system.negativeError};
    margin-bottom: ${rem(16)};
    background-color: ${theme.colors.neutral.gray99};

    p {
      flex: 1 0 auto;
    }

    .nmx-icon {
      .icon-fill {
        fill: ${theme.colors.system.negativeError};
      }
      .icon-color {
        fill: ${theme.colors.neutral.white};
      }
    }
   `}
`;

export const DivModalContainerStyled = styled.div`
  position: absolute;
  &.is-active {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    .nmx-modal {
      display: block;
      @media all and (-ms-high-contrast: none) {
        top: ${rem(50)};
        left: 25%;
      }
    }
    .nmx-modal__overlay {
      display: flex;
      align-items: center;
      margin: auto;
    }
  }
`;

export const DivModalOverlayStyled = styled.div`
  ${({ theme }) => css`
    position: fixed;
    z-index: ${theme.zIndex.modalOverlay};
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: none;
    background-color: rgba(0, 0, 0, 0.5); /** TODO: leverage shadow theme (once organized) */
    overflow-y: scroll;
    .is-active {
      display: flex;
      align-items: center;
      margin: auto;
    }
  `}
`;

export const DivOtherLoginStyled = styled.div`
 ${({ theme }) => css`
    border-top: 1px solid ${theme.colors.neutral.gray59};
    padding-top: ${rem(24)};
    text-align: center;
  `}
`;

export const LabelCheckboxStyled = styled.label`
  display: flex;
  flex-direction: row;
  margin-bottom: ${rem(16)};
`;

export const UlAnnouncementStyled = styled.ul`
  text-align: left;
  li {
    padding-left: ${rem(16)};
    padding-bottom: ${rem(12)};
  }
`;

export const UlLoginLinksStyled = styled.ul`
  display: inline-block;
  li {
    display: inline-block;
    margin: ${rem(8)};
  }
`;

